import React, { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { useCookieConsent } from './CookieConsentContext';
import TrackingContext from './TrackingContext';

const PageTracker = () => {
  const tracking = useContext(TrackingContext);
  const { measurementAllowed } = useCookieConsent();
  const { pathname } = useLocation();
  const prevPathname = useRef<typeof pathname>(null);

  useEffect(() => {
    if (!measurementAllowed) {
      prevPathname.current = null;
    } else if (pathname !== prevPathname.current) {
      tracking.trackPageView(pathname);
      prevPathname.current = pathname;
    }
  }, [measurementAllowed, pathname, tracking]);

  return <></>;
};

export default PageTracker;
